import { NextProjectButton } from './buttons/NextProjectButton';
import { ProjectNameLabel } from './ProjectNameLabel';
import { getDomainCfg, store } from '../core/state';
import { EDITOR_VIEW_NAME, NEXT_PROJECT_BUTTON } from '../core/constants';
import { translate } from '../core/i18n';
import { hideModal, showQuestionModal } from './modals/QuestionModal';
import { getRedirectUrl, redirectTo } from '../features/redirect';

import ModernHeaderButton from './buttons/base/ModernHeaderButton';

import { requestNextProject } from '../features/successsteps';
import { ToggleThemeButton, ModernToggleThemeButton } from './ThemeContext';

export const requestExitEditor = () => {
  const exitDeclined = () => hideModal();
  const exitAccepted = () => {
    hideModal();
    redirectTo(getRedirectUrl(getDomainCfg().viewSettings.projectsView));
  }
  const opts = {
    okTitle : translate("exit-modal-ok"),
    okColor: "btn-primary",
  }
  showQuestionModal(
    translate("exit-modal-title"),
    translate("exit-modal-message"),
    exitAccepted,
    exitDeclined,
    opts
  );
}

export const EditorNavMenu = ({ layout = undefined }) => {  
  const [showNextProjectButton, setShowNextProjectButton] = store.useState(NEXT_PROJECT_BUTTON, {default : false});

  const nextProjectClicked = () => {
    setShowNextProjectButton(false);
    requestNextProject();
  }

  const exitRequested = requestExitEditor;

  const features = getDomainCfg()?.viewSettings?.features;

  return <div className="form-inline">
    { features?.showThemeButton &&
      <ModernToggleThemeButton />
    }
    { features?.showExitButton && showNextProjectButton !== true &&
      <ModernHeaderButton icon="right-to-bracket" onClick={exitRequested} title={translate('exit-btn-title')} text={translate('exit')} variant={'primary'} />
    }
    { showNextProjectButton === true && <NextProjectButton nextProjectRequested={nextProjectClicked} show={showNextProjectButton} floating={false} /> }
  </div>;
}
